import type { GetFamilyEventDetailsOfSmsPath } from '@src/api/event/getFamilyEventDetailsOfSms';
import { useQuery } from 'react-query';

import { getFamilyEventDetailsOfMail } from '@api/event';

export function useGetFamilyEventDetailsOfMail({ eventId }: GetFamilyEventDetailsOfSmsPath) {
  return useQuery(['FAMILY_EVENTS_DETAILS_OF_MAIL', eventId], async () => {
    const response = await getFamilyEventDetailsOfMail({ path: { eventId } });

    console.log({ response });

    return response ? response.rows : [];
  });
}
